import { atom } from 'jotai'

export const selectedGroupIdAtom = atom<string | undefined>(undefined)
export const autoOpenConditionIdAtom = atom<string | undefined>(undefined)
